import { createBrowserClient } from '@supabase/ssr';
import { Database } from 'backend';

let client: ReturnType<typeof createBrowserClient<Database>> | undefined;

export function createClient() {
  if (client) return client;

  try {
    client = createBrowserClient<Database>(
      process.env.NEXT_PUBLIC_SUPABASE_URL!,
      process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    );
    return client;
  } catch (e) {
    // TODO: existing hooks (useUser, useStory, etc.) rely on the fallback
    // being `any`-typed. Remove this and properly type those hooks in a
    // follow-up PR.
    console.error(e);
    return {} as any;
  }
}
